
    import { Component, Vue } from 'vue-property-decorator';
    import Layout from '@/components/layout/Layout.vue';
    import TableComponent from '@/components/table/TableComponent.vue';

    @Component({
        components: {
            Layout,
            TableComponent,
        },
    })
    export default class PartnerIndex extends Vue {
        private keys = {
            id: '#',
            name: 'Názov',
        };

        private links = [
            {
                url: '/partner/:param:',
                image: require('@/assets/image/magnifying-glass.svg'),
            },
            {
                url: '/partner/edit/:param:',
                image: require('@/assets/image/edit.svg'),
            },
        ];

        private apiCall = 'getPartners';
    }
